import React from 'react';

interface KeyPressOptions {
  event?: 'keydown' | 'keyup'; // Limit event options to valid keyboard event types
  target?: Window | HTMLElement | null; // Allow targets like window, HTMLElement, or null
  eventOptions?: AddEventListenerOptions; // Options for event listeners
}

export function useKeyPress(
  key: string, // The key to listen for (e.g., 'Enter', 'Escape')
  cb: (event: KeyboardEvent) => void, // Callback function called when key is pressed
  options: KeyPressOptions = {}, // Options for customization
): void {
  const { event = 'keydown', target = window ?? null, eventOptions } = options;

  React.useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === key) {
        cb(event);
      }
    };

    if (target) {
      // @ts-ignore
      target.addEventListener(event, handler, eventOptions);
      return () => {
        // @ts-ignore
        target.removeEventListener(event, handler, eventOptions);
      };
    }
  }, [key, cb, target, event, eventOptions]);
}
